import { render } from "./WitnessSign.vue?vue&type=template&id=015386b5"
import script from "./WitnessSign.vue?vue&type=script&lang=js"
export * from "./WitnessSign.vue?vue&type=script&lang=js"
script.render = render

export default script